import baseAPI from "@/http";

const router = "api/municipio-faixas";

export const faixaApi = {
  list: () => baseAPI.get(`${router}`),
  create: (faixa) => baseAPI.post(`${router}`, faixa),
  update: (faixa) => baseAPI.put(`${router}`, faixa),
  delete: (faixaId) => baseAPI.delete(`${router}?id=${faixaId}`),
  get: (faixaId) =>
    baseAPI.get(`${router}/obter-municipio-faixa-por-id?id=${faixaId}`),
};

const solucoesRouter = "api/solucoes-faixas";

export const faixaSolucaoApi = {
  list: () => baseAPI.get(`${solucoesRouter}`),
  create: (faixa) => baseAPI.post(`${solucoesRouter}`, faixa),
  update: (faixa) => baseAPI.put(`${solucoesRouter}`, faixa),
  delete: (faixaId) => baseAPI.delete(`${solucoesRouter}?id=${faixaId}`),
  get: (faixaId) =>
    baseAPI.delete(`${router}/obter-solucao-faixa-por-id?id=${faixaId}`, faixa),
};
